var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-index',{ref:"baseIndex",attrs:{"columns":_vm.columns,"resourceName":_vm.resourceName,"pk":_vm.pk,"disabledFilterButton":false,"breadcrumbs":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"render.image",fn:function(ref){
var item = ref.item;
return [_c('div',[_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":item.image}})])]}},{key:"render.publish",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.publish === 1 ? "公開" : "非公開"))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }